import { render, staticRenderFns } from "./PhotosListItem.vue?vue&type=template&id=089b75d2&"
import script from "./PhotosListItem.vue?vue&type=script&lang=js&"
export * from "./PhotosListItem.vue?vue&type=script&lang=js&"
import style0 from "./PhotosListItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports